import { render, staticRenderFns } from "./OpenSessionItem.vue?vue&type=template&id=1021abfb"
import script from "./OpenSessionItem.vue?vue&type=script&lang=js"
export * from "./OpenSessionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports